"use client";

import { useRef, useEffect, useState } from "react";
import Slider, { Settings } from "react-slick";
import Image from "next/image";
import arrowLeft from "../../lib/carousel/arrow_left.png";
import arrowRight from "../../lib/carousel/arrow_right.png";
const styles = new Proxy({"Wrapper":"Wrapper-5f101","Heading":"Heading-5f101","SectionTitle":"SectionTitle-5f101","Subtitle":"Subtitle-5f101","CarouselWrap":"CarouselWrap-5f101","SlideOuter":"SlideOuter-5f101","Card":"Card-5f101","IconCircle":"IconCircle-5f101","Title":"Title-5f101","ListWrapper":"ListWrapper-5f101","CtaWrapper":"CtaWrapper-5f101","CtaButton":"CtaButton-5f101","Controls":"Controls-5f101","Dots":"Dots-5f101","Dot":"Dot-5f101","DotActive":"DotActive-5f101","ArrowBtn":"ArrowBtn-5f101"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });
/*import "./IconCardTitleSlider.scss";*/
import { RichText } from "payload-pms/RichText";
import { ResolvedCard } from "./types";

// Desktop and tablet show exactly 3 cards, mobile shows a single one.
const MOBILE_BREAKPOINT = 768;
const SLIDES_DESKTOP = 3;
const SLIDES_MOBILE = 1;

export default function IconCardTitleCarousel({
  cards,
}: {
  cards: ResolvedCard[];
}) {
  const sliderRef = useRef<Slider>(null);
  const [slidesToShow, setSlidesToShow] = useState(SLIDES_DESKTOP);
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const check = () =>
      setSlidesToShow(
        window.innerWidth < MOBILE_BREAKPOINT ? SLIDES_MOBILE : SLIDES_DESKTOP,
      );
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  // Only page horizontally when there are more cards than fit on screen.
  const pageable = cards.length > slidesToShow;

  const SETTINGS: Settings = {
    dots: false,
    arrows: false,
    slidesToShow,
    slidesToScroll: 1,
    infinite: pageable,
    swipeToSlide: true,
    speed: 300,
    cssEase: "ease",
    afterChange: (index) => setCurrent(index),
  };

  return (
    <div className={styles.CarouselWrap}>
      <Slider ref={sliderRef} {...SETTINGS} className="IconCardTitleSlider">
        {cards.map((card, idx) => (
          <div key={idx} className={styles.SlideOuter}>
            <div className={styles.Card}>
              <div className={styles.IconCircle}>
                <Image
                  src={"url" in card.image ? card.image.url : card.image}
                  width={132}
                  height={124}
                  alt={card.title}
                />
              </div>
              <h4 className={styles.Title}>{card.title}</h4>
              <div className={styles.ListWrapper}>
                {card.content && <RichText content={card.content} />}
              </div>
              {card.ctaUrl && card.ctaLabel && (
                <div className={styles.CtaWrapper}>
                  <a
                    href={card.ctaUrl}
                    className={styles.CtaButton}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {card.ctaLabel}
                  </a>
                </div>
              )}
            </div>
          </div>
        ))}
      </Slider>
      {pageable && (
        <div className={styles.Controls}>
          <button
            className={styles.ArrowBtn}
            onClick={() => sliderRef.current?.slickPrev()}
            aria-label="Previous"
          >
            <Image src={arrowLeft} alt="Previous" width={20} height={29} />
          </button>
          <ul className={styles.Dots}>
            {cards.map((_, i) => (
              <li
                key={i}
                className={
                  i === current % cards.length ? styles.DotActive : styles.Dot
                }
                onClick={() => sliderRef.current?.slickGoTo(i)}
              />
            ))}
          </ul>
          <button
            className={styles.ArrowBtn}
            onClick={() => sliderRef.current?.slickNext()}
            aria-label="Next"
          >
            <Image src={arrowRight} alt="Next" width={20} height={29} />
          </button>
        </div>
      )}
    </div>
  );
}
